._ApplicationDetails_lzo55_1 {
  /* Empty file & class, used as a placeholder for future styling */
}